import { useDocumentURL } from 'modules/document/hooks'
import { useEffect, useState } from 'react'

const useAudioBlobURL = (url?: string) => {
  const [audioBlobURL, setAudioBlobURL] = useState<string | null>(null)

  const { documentURL } = useDocumentURL({ s3PrivateURL: url })

  useEffect(() => {
    if (!documentURL) return
    let objectURL: string
    fetch(documentURL)
      .then((res) => res.blob())
      .then((blob) => {
        objectURL = URL.createObjectURL(blob)
        setAudioBlobURL(objectURL)
      })
      .catch(() => setAudioBlobURL(documentURL))
    return () => {
      if (objectURL) URL.revokeObjectURL(objectURL)
    }
  }, [documentURL])

  return audioBlobURL
}

export default useAudioBlobURL
